import template from './acris-blogs-index.html.twig';

Shopware.Component.register('acris-blogs-index', {
    template
});
